import api from "./api";

async function uploadErpFile(file) {
  const data = new FormData();
  data.append("file", file);

  try {
    const response = await api.post(
      `api/erpfiles`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.status; // 202 Accepted expected
  } catch (error) {
    return null;
  }
}

export { uploadErpFile };


